export interface Project {
  id: string;
  name: string;
  description: string;
  icon: string;
  path: string;
  lastAccessed?: string;
}

export const projects: Project[] = [
  {
    id: 'sales-assistant',
    name: 'Sales Assistant',
    description: 'Sales guidance using motivational dimensions',
    icon: '💼',
    path: '/project/sales-assistant'
  },
  {
    id: 'job-grids',
    name: 'Job Grids',
    description: 'Generate job descriptions aligned with motivational profiles',
    icon: '📋',
    path: '/project/job-grids'
  },
  {
    id: 'mcode-translation',
    name: 'MCODE Language Translation',
    description: 'Transform text into motivational dimensions focused language',
    icon: '🌐',
    path: '/project/mcode-translation'
  },
  {
    id: 'case-studies',
    name: 'Case Studies',
    description: 'Create case studies based on motivational dimensions',
    icon: '📚',
    path: '/project/case-studies'
  }
];